/* eslint-disable */
import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { RegularButton, AlertAdapter } from 'pg-ui-library';
import {
  ModalContent,
  Header,
  AllContent,
  MainContent,
  Footer,
  UploadContainer,
  UploadBox,
  FileNameContainer,
  UploadText,
  RemoveFileButton,
} from './styles';
import { useUploadExternalClientUsers } from '../../mutations/external-user.mutation';

export const BulkExternalClientUserModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onSuccess?: () => void;
}> = ({ isOpen, onRequestClose, onSuccess }) => {
  const [file, setFile] = useState<File | null>(null);
  const uploadUsers = useUploadExternalClientUsers();
  const allowedExtensions = ['xlsx', 'xls', 'csv'];

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;
    const extension = selectedFile.name.split('.').pop()?.toLowerCase();
    if (!extension || !allowedExtensions.includes(extension)) {
      AlertAdapter('Only XLSX, XLS and CSV files are allowed', 'error');
      event.target.value = '';
      return;
    }
    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      AlertAdapter('Please select a file first', 'error');
      return;
    }

    try {
      await uploadUsers.mutateAsync(file);

      setFile(null);

      handleClose();

      onSuccess?.();
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    setFile(null);
    onRequestClose();
  };

  const clearFile = () => {
    setFile(null);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.6)',
        },
        content: {
          borderRadius: '30px',
          width: '760px',
          height: '480px',
          margin: 'auto',
          padding: '0',
          background: '#F3F4F8',
        },
      }}
    >
      <ModalContent>
        <Header>
          <h3>Bulk Upload External Client Users</h3>
        </Header>
        <AllContent>
          <MainContent>
            <div
              style={{
                marginTop: '30px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <UploadContainer>
                <UploadBox>
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    disabled={uploadUsers.isLoading}
                    onChange={handleFileChange}
                  />
                  <div>Click to select file</div>
                  <UploadText>Supported formats: XLSX, XLS, CSV</UploadText>
                </UploadBox>

                {file && (
                  <FileNameContainer>
                    <span>
                      📄 {file.name} ({(file.size / 1024).toFixed(2)} KB)
                    </span>
                    <RemoveFileButton type="button" onClick={clearFile}>
                      ×
                    </RemoveFileButton>
                  </FileNameContainer>
                )}
              </UploadContainer>
            </div>
          </MainContent>
          <Footer>
            <RegularButton
              type="button"
              onClick={handleClose}
              style={{
                background: '#fff',
                color: '#4948AC',
              }}
            >
              Cancel
            </RegularButton>
            {/* <RegularButton
                            type="button"
                            onClick={handleUpload}
                            disabled={!file}
                        >
                            Upload
                        </RegularButton> */}

            <RegularButton type="button" onClick={handleUpload} disabled={!file || uploadUsers.isLoading}>
              {uploadUsers.isLoading ? 'Uploading...' : 'Upload'}
            </RegularButton>
          </Footer>
        </AllContent>
      </ModalContent>
    </ReactModal>
  );
};
